const riot = require('riot');

riot.tag2('page-works-single', '<div class="bg-cream h-full f flex-column"> <div class="flex-fixed" data-is="module-header" title="{t(&quot;works_single.title&quot;)}" back="{true}"> <yield to="right"> <button type="submit" form="work_form">{t(⁗header.save⁗)}</button> </yield> </div> <form class="container px16 pt20 s-full overflow-scroll" id="work_form" ref="form" onsubmit="{done}"> <div class="f flex-between pb21 border-bottom border-dark-012"> <div class="f fm fs16 fw6">{t(⁗works_single.icon⁗)}</div> <div class="f"> <div class="mr16 flex-fixed s66 border bw4 border-primary-light"><img class="s-full object-fit-cover" riot-src="{selectedImage &amp;&amp; selectedImage.normal || work &amp;&amp; work.icon_url.normal || images[0].url.normal}"></div> <div class="f fm"> <div class="bg-primary-light rounded-4 py14 px50 text-white fs13 fw6 letter-spacing-0 f fh cursor-pointer" onclick="{openModalImage}">{t(⁗works_single.change⁗)}</div> </div> </div> </div> <div class="pt24 border-bottom border-dark-012"> <div class="f flex-between fm"> <div class="fs16 fw6">{t(⁗works_single.work_title⁗)}</div> <div class="text-danger fw5" if="{refs.form.title.value.length &gt; 30}">{t(⁗works_single.error_message⁗)}</div> </div> <input class="w-full pt20 pb24 fs16 placeholder-opacity-0_5 lh13" name="title" placeholder="{t(&quot;works_single.placeholder&quot;)}" riot-value="{work.title}" oninput="{_.noop}"> </div> <div class="pt24"> <div class="fs16 fw6">{t(⁗works_single.reward⁗)}</div> <select class="w-full pt20 pb24" ref="reward"> <option each="{num in getRange()}" selected="{num === work.reward}" riot-value="{num}">{num}{app.utils.getCurrencyText(currency, num !== ⁗1.00⁗)}</option> </select> </div> </form> </div>', '', '', function(opts) {
    this.preload = async({req, res}) => {
      var child_id = req.params.child_id;

      if (req.params.work_id !== "new") {
        var work_res = await app.api.request({
          method: 'get',
          url: '/web' + req.url,
        });
      }

      var me_res = app.api.request({
        method: 'get',
        url: '/web/me',
      });

      var assets_res = app.api.request({
        method: 'get',
        url: '/web/assets',
        params: {
          kind: "work_icon",
        },
      });

      var promises = [
        me_res,
        assets_res,
        work_res,
      ];

      var items = await Promise.all(promises);

      return {
        id: req.params.work_id,
        child_id,
        currency: items[0].data.family.currency,
        images: items[1].data.assets,
        work: items[2] && items[2].data.work,
      }
    };

    this.getRange = () => {
      var step_0_05 = _.range(5, 21, 5).map(num => (num / 100).toFixed(2));
      var step_0_1 = _.range(30, 501, 10).map(num => (num / 100).toFixed(2));
      return {
        "JPY": _.range(1, 10).concat(_.range(10, 501, 10)),
        "USD": [...step_0_05, ...step_0_1],
        "EUR": [...step_0_05, ...step_0_1],
        "GBP": [...step_0_05, ...step_0_1],
        "NTD": _.range(1, 51),
      }[this.currency];
    };

    this.openModalImage = () => {
      var modal = spat.modal.open('modal-image-select', { images: this.images });
      modal.on('selected', (image) => {
        this.selectedImage = image;
        this.update();
      });
    };

    this.done = async(e) => {
      e.preventDefault();

      if (!this.selectedImage) {
        this.selectedImage = this.work && this.work.icon_url || this.images[0].url;
      }

      var data = {
        icon_url: this.selectedImage,
        title: this.refs.form.title.value,
        reward: Number(this.refs.reward.value),
      };

      var method = this.id === "new" ? "post" : "put";
      var url = this.id === "new" ? `/web/children/${this.child_id}/works` : `/web/children/${this.child_id}/works/${this.id}`;

      try {
        await app.api.request({
          method,　url,　data
        });
        spat.modal.alert(t("message.saved"));
        var works_url = this.id === "new" ? `/children/${this.child_id}/works?added=true` : `/children/${this.child_id}/works`
        spat.router.push(works_url);
      }
      catch(error) {

      }

    };
});